export enum LifecycleEventType {
  COUPON = 'COUPON',
  REDEMPTION = 'REDEMPTION',
  CALL_EVENT = 'CALL_EVENT',
  FIXED = 'FIXED_COUPON',
  FIXED_TO_FORWARD = 'FIXED_TO_FORWARD',
  INITIAL_FIXING = 'INITIAL_FIXING',
  CALL = 'CALL',
  FINAL_FIXING = 'FINAL_FIXING',
  FLOATING = 'FLOATING',
  CONDITIONAL = 'CONDITIONAL',
  SNOWBALL = 'SNOWBALL',
  AUTOCALL = 'AUTOCALL',
  ISSUER_CALL = 'ISSUER_CALL',
  KNOCK_IN_PUT_DOWNSIDE = 'KNOCK_IN_PUT',
  FIXED_DOWNSIDE = 'FIXED',
  PUT_DOWNSIDE = 'PUT',
  ISSUE = 'ISSUE',
}

export const LifecycleEventTypeLabel = {
  [LifecycleEventType.COUPON]: 'Coupon',
  [LifecycleEventType.REDEMPTION]: 'Redemption',
  [LifecycleEventType.CALL_EVENT]: 'Call Event',
  [LifecycleEventType.FIXED]: 'Fixed Coupon',
  [LifecycleEventType.FIXED_TO_FORWARD]: 'Fixed to Forward',
  [LifecycleEventType.INITIAL_FIXING]: 'Initial Fixing',
  [LifecycleEventType.CALL]: 'Call',
  [LifecycleEventType.FINAL_FIXING]: 'Final Fixing',
  [LifecycleEventType.FLOATING]: 'Floating Coupon',
  [LifecycleEventType.CONDITIONAL]: 'Conditional Coupon',
  [LifecycleEventType.SNOWBALL]: 'Snowball Coupon',
  [LifecycleEventType.AUTOCALL]: 'Autocall',
  [LifecycleEventType.ISSUER_CALL]: 'Issuer Call',
  [LifecycleEventType.KNOCK_IN_PUT_DOWNSIDE]: 'Knock-in Put',
  [LifecycleEventType.FIXED_DOWNSIDE]: 'Fixed',
  [LifecycleEventType.PUT_DOWNSIDE]: 'Put',
  [LifecycleEventType.ISSUE]: 'Issue',
};
